<div class="content-wrapper">
    <div class="content-body">
        <div id="user-profile">
            <section id="profile-info">
                <div class="row">
                    <div class="col-lg-9 col-12 order-1 order-lg-2">
                        <div class="form-group mb-2">
                            <div class="card">
                                <div class="card-header">
                                    <h2>Insights Information - {{data?.heading}}</h2>
                                </div>
                                <div class="card-body">

                                   <quill-editor class="university-info" [(ngModel)]="contentData"
                                                  name="quill-content"></quill-editor>
                                </div>
                                <div class="card-footer">
                                    <button class="btn btn-primary pull-right" rippleEffect (click)="submit()">
                                        <i data-feather="submit" class="d-block d-md-none"></i>
                                        <span class="font-weight-bold d-none d-md-block">Submit</span>
                                    </button>
                                </div>
                            </div>
                            <div class="card">
                                <div class="blog-form p-2">
                                    <form (ngSubmit)="saveFaq()">
                                        <h3 class=" ">FAQs</h3>
                                        <div *ngFor="let faq of faqs; let i = index" class="pt-2 border border-bottom p-1 position-relative  mb-2 w-100">
                                            <button
                                                    *ngIf="faqs.length > 1 && i !== faqs.length - 1"
                                                    type="button"
                                                    class="position-absolute btn"
                                                    style="top: -10px; right: 0px"
                                                    (click)="removeFaq(i)">
                                                <i class="fa fa-minus text-danger"></i>
                                            </button>
                                            <button
                                                    *ngIf="i === faqs.length - 1"
                                                    type="button"
                                                    class="position-absolute btn text-success"
                                                    style="top: -10px; right: 0px"
                                                    (click)="addFaq()">
                                                <i class="fa fa-plus"></i>
                                            </button>
                                             <input
                                                        type="text"
                                                        placeholder="Question"
                                                        [(ngModel)]="faq.question"
                                                        name="question{{i}}"
                                                        class="border p-1 w-100 mb-2 outline-none"
                                                        required
                                                />
                                            <textarea
                                                    placeholder="Answer"
                                                    [(ngModel)]="faq.answer"
                                                    name="answer{{i}}"
                                                    class="border p-1 resize-none w-100 outline-none"
                                                    required
                                            ></textarea>
                                        </div>
                                        <div class="text-center">
                                            <button class="btn btn-primary" type="submit">Save Faq</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-12 order-3">
                        <div class="card">
                            <div class="card-body">
                                <h5 class="mb-0">Latest Photos</h5>
                                <div class="row">
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-body">
                                <h5 class="mb-2">Suggestions</h5>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-body">
                                <h5 class="mb-1">Polls</h5>
                                <p class="card-text mb-0">Who is the best actor in Marvel Cinematic Universe?</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>

